<template lang="pug">
table.table.table-fixed(:class='tableClass')
  thead
    tr(style="text-align: left; font: Bold 15px/17px Helvetica; letter-spacing: 0px; color: #343A40; opacity: 1;")
      th(v-for='c in columns', :key='c.title') {{c.title}}
  tbody
    tr(v-if='this.inlineFilter === true', style="background: #EAEAEA 0% 0% no-repeat padding-box; opacity: 1;")
      td(width="32px")
      td
      td 
        select#type(@change="onTypeChange($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;width:100%;")
          option( value='') Tất cả
          option(v-for='(o, i) in lstType' :value='o.key') {{o.value}}
      td
        select#status(@change="onStatusChange($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
          option(value='') Tất cả
          option(v-for='(o, i) in lstStatus' :value='o.key') {{o.value}}
      td
      td
    tr(v-if='this.data.length === 0' style="white-space: nowrap;") Không có dữ liệu
    tr(v-for='(item, index) in data' v-bind:id="'row' + item.id")
      td(v-for='c in columns')
        div(v-if='hasValue(item, c)', v-html='itemValue(item, c, index)')
        div(v-if='hasValue(item, c) === "type" && !isCustom(c)')
          select#type(@change="sendLink($event, item)" :disabled="item.user_id_requested === $store.getters.user && item.status === 1"
            style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;width:100%;")
            option(v-for='(o, i) in lstType' :value='o.key' :selected="o.key === item[c.key]") {{o.value}}
        div(v-if='isCustom(c) && item.status === 1 && item.user_id_requested === $store.getters.user')
          .box-action(@click='accept(item)')
            .box-item-check
              img(src="../../assets/images/faces/ic_check.svg")
            span Chấp nhận
          .clearfix
          .box-action(@click='refuse(item)')
            .box-item-refuse
              img(src="../../assets/images/faces/ic_clear.svg")
            span Từ chối
        div(v-if='isCustom(c) && item.status === 1 && item.user_id_request === $store.getters.user', v-bind:id='"action" + item.id' style="text-align: center;")
          i.material-icons.text-gray(style="cursor:pointer") more_horiz
          b-popover.relation-popover(:target='"action" + item.id' triggers="hover" placement="top") 
            template
              div(style="width: 110px; height: 40px; background: #E0E0E0 0% 0% no-repeat padding-box;box-shadow: 0px 1px 0px #00000029;opacity: 1;")
                .cancel-link(v-if="item.status === 2" @click="cancelLink(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy kết bạn
                .cancel-request(v-if="item.status === 1" @click="cancelRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy yêu cầu
                .remove-request(v-if="item.status === 3" @click="removeRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Xóa yêu cầu
        div(v-if='isCustom(c) && item.status !== 1', v-bind:id='"action" + item.id' style='text-align: center;')
          i.material-icons.text-gray(style="cursor:pointer") more_horiz
          b-popover(:target='"action" + item.id' triggers="hover" placement="top") 
            template
              div(style="width: 110px; height: 40px; background: #E0E0E0 0% 0% no-repeat padding-box;box-shadow: 0px 1px 0px #00000029;opacity: 1;")
                .cancel-link(v-if="item.status === 2" @click="cancelLink(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy kết bạn
                .cancel-request(v-if="item.status === 1" @click="cancelRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy yêu cầu
                .remove-request(v-if="item.status === 3" @click="removeRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Xóa yêu cầu
</template>

<script>
import moment from 'moment'

export default {
  props: {
    columns: Array,
    data: Array,
    actions: Array,
    type: {
      type: String, // default | striped | hover
      default: ''
    },
    inlineFilter: {
      type: Boolean,
      default: false
    },
    lstStatus: Array,
    lstType: Array
  },
  computed: {
    tableClass() {
      return `table-${this.type}`
    }
  },
  methods: {
    accept(item) {
      // console.log('accept: ' + id)
      this.$emit('onAccept', item)
    },
    refuse(item) {
      // console.log('refuse: ' + id)
      this.$emit('onRefuse', item)
    },
    sendLink(e, item) {
      var data = {
        id: e.target.value,
        uidRequested: item.user_id_requested
      }
      this.$emit('onSendLink', data)
    },
    cancelLink(item) {
      this.$emit('onCancelLink', item)
    },
    cancelRequest(item) {
      this.$emit('onCancelRequest', item)
    },
    removeRequest(item) {
      this.$emit('onRemoveRequest', item)
    },
    hasValue(item, col) {
      // console.log(item, col)
      if (col.type === 'action' || item[col.key] === 'undefined' || col.type === 'custom') {
        return false
      } else if (col.type === 'type') {
        return 'type'
      } else {
        return true
      }
    },
    fmDate(item, col) {
      return moment(item[col.key]).format('DD/MM/YYYY - hh:mm')
    },
    isAction(col) {
      if (col.type === 'action') return true
      else return false
    },
    isCustom(col) {
      if (col.type === 'custom') return true
      else return false
    },
    itemValue(item, column, index) {
      var value = item[column.key]
      if (column.type) {
        if (column.type === 'date') {
          return this.fmDate(item, column)
        } else if (column.type === 'custom') {
          return value
        } else if (column.type === 'seq') {
          return index + 1
        } else if (column.type === 'type') {
          return null
        } else if (column.type === 'status') {
          for (let i = 0; i < this.lstStatus.length; i++) {
            if (this.lstStatus[i].key === value) {
              if (item.user_id_request === this.$store.getters.user && this.lstStatus[i].key === 1) return 'Đã gửi yêu cầu'
              else return this.lstStatus[i].value
            }
          }
        }
      } else {
        if (typeof value === 'object') {
          if (item.user_id_requested === this.$store.getters.user) value = item.userRequest
          var avt = value.avatar !== null ? value.avatar : require('../../assets/images/faces/ic_AvatarDefault.svg')
          return '<div><div style="width:48px;height:48px; float:left;border-radius:50%;overflow:hidden;"><img src="' + avt + '" style="max-width:100%; height:auto;"/></div><div style="display: inline-block; padding: 15px 8px 0; font-size:15px;">' + value.fullname + '</div></div>'
        }
        return value
      }
    },
    onStatusChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbystatus', event.target.value)
    },
    onTypeChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbytype', event.target.value)
    }
  }
}

</script>
<style lang="scss">
.list-action {
  cursor: pointer;
}
.popover.b-popover {
    display: block;
    opacity: 1;
    outline: 0;
}
.popover {
    top: 0;
    left: 0;
    z-index: 1060;
    max-width: 276px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    // font-size: .875rem;
    word-wrap: break-word;
    // background-color: #fff;
    // background-clip: padding-box;
    // border: 1px solid rgba(0,0,0,.2);
    // border-radius: .3rem;
    background: #E0E0E0 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 0px #00000029;
}
// .cancel-request, .remove-request,
// .cancel-link{
//   &:hover {color: green !important;}
// }
select[disabled]{background: #EAEAEA 0% 0% no-repeat padding-box !important; border: 1px solid #B4B4B4;}
.table-fixed{position: relative;
  // tr{
  //   &:first-child{position: fixed; width: 100%;}
  // }
}
.box-action {
  display: inline-flex;
  cursor: pointer;
  .box-item-check {
    width: 24px;
    img {max-width: 100%; height: auto;}
  }
  .box-item-refuse {
    width: 24px;
    img {max-width: 100%; height: auto;}
  }
  span {padding-top: 4px; padding-left: 10px;color: #9B9B9B;}
}
table {
  tbody {
    tr {
      td {
        select {
          border-radius: 10px !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// tableRelation.vue?6cb22c98